<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Komisi</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <div
                class="section curved-header pt-1"
                style="--height-curved:100px;"
            >
                <div class="wallet-card">
                    <div class="col-12 text-center text-primary">
                        <div
                            style="color: #17273e;font-weight: 500;display: block;font-size: 13px;"
                        >
                            <span>Total Komisi</span>
                        </div>
                        <h3 class="text-primary truncate-text">
                            <span>Rp {{ customer.komisi | rupiah }}</span>
                        </h3>
                    </div>
                    <div class="wallet-footer">
                        <router-link
                            :to="{ name: 'withdrawal' }"
                            class="btn btn-primary btn-block"
                            @click="actionSheet('show')"
                        >
                            <ion-icon
                                name="caret-down-circle-outline"
                            ></ion-icon>
                            Tarik Komisi
                        </router-link>
                    </div>
                </div>
            </div>
            <!-- <div class="section mt-2">
                <router-link :to="{name:'withdrawal'}" class="btn btn-primary btn-block"><ion-icon name="archive"></ion-icon> Tarik Komisi</router-link>
            </div> -->
            <div class="section" style="margin-top:50px;">
                <div v-if="komisi.data.length > 0">
                    <div class="card">
                        <div class="table-responsive">
                            <table
                                class="table rounded table-min"
                                style="font-size:11px;line-height:13px;"
                            >
                                <thead>
                                    <tr
                                        style="background:rgba(233, 233, 236, 0.4);"
                                    >
                                        <th scope="col">Keterangan</th>
                                        <th scope="col" class="text-right">
                                            Nominal
                                        </th>
                                        <th scope="col" class="text-right">
                                            Komisi
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in komisi.data"
                                        :key="item.id"
                                    >
                                        <td>
                                            <div style="font-weight: bold;">
                                                {{
                                                    dateMutation(
                                                        item.created_at
                                                    )
                                                }}
                                            </div>
                                            <div>{{ item.description }}</div>
                                        </td>
                                        <td class="text-right text-nowrap">
                                            <span
                                                :class="
                                                    item.type == '+'
                                                        ? 'text-success'
                                                        : 'text-danger'
                                                "
                                                >{{ item.type }} Rp
                                                {{
                                                    item.nominal | rupiah
                                                }}</span
                                            >
                                        </td>
                                        <td
                                            class="text-right text-primary text-nowrap"
                                        >
                                            Rp {{ item.komisi | rupiah }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="m-2 text-center" v-if="komisi.next_page_url">
                        <ButtonLoader
                            :loading="loadingButton"
                            :styled="'btn btn-primary rounded mr-1 mb-1'"
                            @click.native="paginateKomisi(komisi.next_page_url)"
                            >Lihat lebih banyak</ButtonLoader
                        >
                    </div>
                </div>
                <div class="text-center" style="margin-top:50px;" v-else>
                    <img
                        :src="require('@/assets/image/empty.webp')"
                        alt="404"
                        class="w-75 mb-3"
                    /><br />
                    <i>Data belum tersedia</i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $axios from './../../api.js';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    export default {
        data() {
            return {
                affiliate_id: '',
                loadingApp: true,
                loadingButton: false,
                komisi: {
                    data: [],
                },
                komisi_total: 0,
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            paginateKomisi(url = '') {
                this.getCustomer();
                this.loadingButton = true;
                $axios
                    .get(url ? url : '/referral/komisi')
                    .then(response => {
                        if (!this.komisi.data) {
                            this.komisi = response.data.data;
                        } else {
                            this.komisi.data.push(...response.data.data.data);
                            this.komisi.next_page_url =
                                response.data.data.next_page_url;
                        }
                        this.loadingButton = false;
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingButton = false;
                        this.loadingApp = false;
                    });
            },
            dateMutation(date) {
                return moment(date).format('D MMM YYYY H:mm:ss');
            },
        },
        mounted() {
            this.paginateKomisi();
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
